import React, { useState } from 'react';
import { clipThumbnailUrl } from '../utils/clipThumbnail';

// Preview image of a transaction clip, filling its (position: relative)
// parent. Renders nothing for clips without an image (older clips), so the
// existing placeholder shows instead.
export default function ClipThumbnail({ videoUrl }) {
  const [failed, setFailed] = useState(false);
  const src = clipThumbnailUrl(videoUrl);
  if (!src || failed) return null;
  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      draggable={false}
      onError={() => setFailed(true)}
      style={{
        position: 'absolute', inset: 0, width: '100%', height: '100%',
        objectFit: 'cover', borderRadius: 'inherit', pointerEvents: 'none', zIndex: 0,
      }}
    />
  );
}
